import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  items: [],
  unreadCount: 0,
};

const slice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setItems(state, action) {
      state.isLoading = false;
      state.items = action.payload;
    },
    setUnreadCount(state, action) {
      state.unreadCount = action.payload;
    },
    applyMarkRead(state, action) {
      const id = action.payload;
      const notification = state.items.find((item) => item.id === id);
      if (notification && !notification.read) {
        notification.read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    applyMarkAllRead(state) {
      state.items.forEach((item) => { item.read = true; });
      state.unreadCount = 0;
    },
  },
});

export default slice.reducer;

const API = process.env.REACT_APP_HOST_API;

// ----------------------------------------------------------------------

export function fetchNotifications() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${API}/notifications`);
      dispatch(slice.actions.setItems(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Notifications/List/InternalError'));
    }
  };
}

export function fetchUnreadCount() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${API}/notifications/unread-count`);
      dispatch(slice.actions.setUnreadCount(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Notifications/UnreadCount/InternalError'));
    }
  };
}

export function markRead(id) {
  return async (dispatch) => {
    dispatch(slice.actions.applyMarkRead(id));
    try {
      await axios.patch(`${API}/notifications/${id}/read`);
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Notifications/MarkRead/InternalError'));
    }
  };
}

export function markAllRead() {
  return async (dispatch) => {
    dispatch(slice.actions.applyMarkAllRead());
    try {
      await axios.patch(`${API}/notifications/read-all`);
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Notifications/MarkAllRead/InternalError'));
    }
  };
}
